/**
 * @file WaitForLoad.js
 *
 * A first attempt at a smart event based module initialising system
 *
 * @author Stanley Clark <stanley@studyportals.com>
 * @copyright © 2016 StudyPortals B.V., all rights reserved.
 * @version 1.0.0
 */

/**
 * Import a series of modules and then fire a callback
 *
 * @param {{name:string, event:string}[]} modules
 * @param callback
 */

import { checkNamespace } from './Namespace.js';

export const waitForLoad = function (modules, callback) {
	if (Object.prototype.toString.call(modules) !== '[object Array]') {
		console.warn('Unable to find any modules. Passed in modules must be an array.');
		callback(false);
	}

	const modulesLoaded = [];

	for (let i = 0; i < modules.length; i++) {
		modulesLoaded.push(false);

		const objectExists = checkNamespace(modules[i].name);
		const windowExists = typeof window[modules[i].name] !== 'undefined';

		let hasInitState = false;
		let initState = false;

		if (windowExists) {
			hasInitState = typeof window[modules[i].name].initialised !== 'undefined';
			initState = window[modules[i].name].initialised;
		}

		if (objectExists || (windowExists && !hasInitState) || (windowExists && hasInitState && initState === true)) {
			modulesLoaded[i] = true;
			checkCompleteStatus();
		} else {
			window.addEventListener(modules[i].event, () => {
				modulesLoaded[i] = true;
				checkCompleteStatus();
			});

			document.addEventListener(modules[i].event, () => {
				modulesLoaded[i] = true;
				checkCompleteStatus();
			});
		}
	}

	function checkCompleteStatus() {
		const uniqueArray = modulesLoaded.filter((v, i, a) => a.indexOf(v) === i);

		if (uniqueArray.length === 1 && uniqueArray[0] === true) {
			callback();
		}
	}
};
